module.exports = __webpack_public_path__ + "static/media/objects2_26.485d2f47.svg";